export default __webpack_public_path__ + "static/media/toggle.6c5f8cc6.svg";